import React from 'react';
import I18n from 'i18n-js';

import { Paths } from '../../shared/url_helpers';
import { redirectToSignin, redirectToSignup } from '@reverbdotcom/commons/src/signup_signin_helper';

const SOURCE = 'ReverbHeader';

export default function LogIn() {
  function handleSignUp(event) {
    event.stopPropagation();
    event.preventDefault();

    redirectToSignup(SOURCE);
  }

  function handleLogIn(event) {
    event.stopPropagation();
    event.preventDefault();

    redirectToSignin(SOURCE);
  }

  return (
    <>
      <li>
        <a
          href={Paths.signup.expand({ query: {} })}
          className="reverb-header__nav__link"
          onClick={handleSignUp}
        >
          {I18n.t('discovery.reverbHeader.signUp')}
        </a>
      </li>
      <li>
        <a
          href={Paths.signin.expand({ query: {} })}
          className="reverb-header__nav__link"
          onClick={handleLogIn}
        >
          {I18n.t('discovery.reverbHeader.logIn')}
        </a>
      </li>
    </>
  );
}
